import { BasicService } from './core/basic.service';

export class GoodsService extends BasicService {

  static homeData() {
    return this.http.post('/goods/shopIndex').then(data => {
      data.slide.forEach(item => {
        item.images_url = this.spliceImg(item.images_url);
      });
      data.hotGoods.forEach(item => {
        item.original_img = this.spliceImg(item.original_img);
      });
      return data;
    });
  }

  static goodsList(data) {
    return this.http.post('/goods/goodsList', data);
  }

  static goodsDetail(goods_id) {
    return this.http.post('/goods/goodsDetails', { goods_id });
  }

  static handleArray(array = []) {
    array.forEach(item => {
      item.label = item.name;
      item.value = item.id;
    });
  }

  static addCollect(goods_id) {
    return this.http.post('/user/collectAdd', { goods_id })
  }

  static removeCollect(collect_id) {
    return this.http.post('/user/collectDel', { collect_id })
  }

  static addCart(goods_id,amount) {
    return this.http.post('/order/shoppingCartAdd', { goods_id,goods_num:amount })
  }

   static async getCartList() {
    return this.http.post('/order/shoppingCartList')
  }

  static async shoppingCartDel(cart_ids) {
    return this.http.post('/order/shoppingCartDel',{ cart_ids })
  }

  static async editCart(cart_id,goods_num) {
    return this.http.post('/order/shoppingCartEdit',{ cart_id,goods_num })
  }

  static async goodsCertificatesZipDownLoad(goods_id) {
    return this.http.get('/goods/goodsCertificatesZipDownLoad',{ goods_id })
  }

  static async goodsCertificates(goods_id) {
    return this.http.post('/goods/goodsDataList',{ goods_id })
  }

  static downloadCertifcates(fileName) {
    return this.http.post(`/file/download?fileName=${fileName}`);
  }

  static downloadCertifcatePackage(goods_id) {
    const url = this.http.baseUrl + '/goods/goodsCertificatesZipDownLoad?goods_id=' + goods_id + '&token=' + localStorage.getItem('token');
    window.open(url);
  }

  static downloadCertifcatePackage2(goods_id) {
    const url = this.http.baseUrl + '/goods/goodsBatchZipDownLoad?goods_id=' + goods_id + '&token=' + localStorage.getItem('token');
    window.open(url);
  }
}